import React from 'react';
import { signupList } from './data';
import './Styles/SignupForm.scss';
import Slider from './Slider';
import Input from '../../Shared/Input/Input';
import { Link } from 'react-router-dom';
const SignupForm=()=>{
    return(
        <div className="signup-form">
        <div className="bg-part">
            <ul className="mainul">
                {signupList.map((item) =>{
                    return(
                        <li>
                            <div className="circle">
                                <div className="icon">
                                    {item.icon}
                                </div>
                            </div>
                            <h2>{item.title}</h2>
                            <p>{item.desc}</p>
                        </li>
                    )
                })}
            </ul>
            <Slider />
        </div>
        <div className="container">

        <div className="form-container" data-aos="zoom-in"
              data-aos-delay={100}>
            <h2>Create an account</h2>
            <p className="sub">Create your free account without any limits, no credit card required.</p>
            <Input 
            type="email"
            label="Work Email Address"
            />
            <Input 
            type="text"
            label="Username"
            />
            <Input 
            type="text"
            label="First Name"
            />
            <Input 
            type="text"
            label="Last Name"
            />
            <Input 
            type="text"
            label="Role"
            />
            <Input 
            type="password"
            label="Password"
            />
            <p>Your password must be at least 5 characters, and can’t begin or end with a space.</p>
            <Input 
            type="password"
            label="Confirm Password"
            />
            <div className="inputcheck">
                <input type="checkbox" />
                <p>By proceeding , you agree to the <Link to="terms-conditions">Terms and conditions</Link></p>
            </div>
            <button>Get started</button>
            <p className="loginp">Already have an account? <Link to="login">Log In</Link></p>
        </div>
        </div>
        </div>
    )
};
export default SignupForm ;